import { ActionableTrainGridItem } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem";
import { ColumnDefinition } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/DropsTableGrid";
import {
  ACTIONABLE_TRAIN_SECTION_COLLAPSED_WIDTH,
  ACTIONABLE_TRAIN_SECTION_CSS_CONTAINER_NAME,
  ACTIONABLE_TRAIN_SECTION_FLEX_BASE,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/utils";
import {
  AltTransIncidentTrain,
  AltTransTrainId,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { tokens } from "shared/components/Spor";
import styled, { css } from "styled-components";
import { AssistanceEventGridItem } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/AssistanceEventGridItem";
import { AssistanceEvent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/AssistanceEventGridItem/AssistanceType";

export const ActionableTrainSectionWrapper = styled.div<{
  $collapsed: boolean;
}>`
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;

  container-name: ${ACTIONABLE_TRAIN_SECTION_CSS_CONTAINER_NAME};
  container-type: inline-size;

  gap: ${tokens.default.size.spacing[4]};

  background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  border-radius: ${tokens.default.size.spacing[1]};

  padding: ${tokens.default.size.spacing[2]};

  ${({ $collapsed }) =>
    $collapsed
      ? css`
          flex: 0 0 ${ACTIONABLE_TRAIN_SECTION_COLLAPSED_WIDTH};
        `
      : css`
          // Base large size. Everything can grow, but inside should not shrink until it has to
          flex: 1 0 ${ACTIONABLE_TRAIN_SECTION_FLEX_BASE};
        `}
`;

const altTransTrainIdKey = (trainId: AltTransTrainId) =>
  `${trainId.countryCode}_${trainId.id}_${trainId.nominalDate}`;

export const actionableTrainTrainTableItemRenderer = (
  item: AltTransIncidentTrain,
  collapsed: boolean,
) => (
  <ActionableTrainGridItem
    key={altTransTrainIdKey(item.id)}
    actionableTrain={item}
    collapsed={collapsed}
  />
);

export const assistanceEventTableItemRenderer = (
  item: AssistanceEvent,
  collapsed: boolean,
) => (
  <AssistanceEventGridItem
    key={item.uuid}
    assistanceEvent={item}
    collapsed={collapsed}
  />
);

export function getActionableTrainAssistanceColumns(
  sectionCollapsed: boolean,
): ColumnDefinition[] {
  switch (sectionCollapsed) {
    case true:
      return [{ label: "Spesialbehov" }];
    case false:
      return [
        { label: "Spesialbehov" },
        { label: "Tog" },
        { label: "Fra stasjon" },
        { label: "Til stasjon" },
      ];
  }
}

export function getActionableTrainTrainColumns(
  sectionCollapsed: boolean,
  isCentreSection: boolean,
): ColumnDefinition[] {
  switch (sectionCollapsed) {
    case true:
      return [{ label: "Tog og rute" }];
    case false:
      return [
        { label: "Tog og rute" },
        { label: "Status" },
        { label: isCentreSection ? "Avgang" : "Ankomst" },
        { label: "Reisende" },
      ];
  }
}
